import React, { useState } from 'react';
import { Phone, Clock, Shield, Star, CheckCircle, Snowflake, Zap, Droplets, Award, Users, ThumbsUp, MessageCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { 
  Accordion, 
  AccordionContent, 
  AccordionItem, 
  AccordionTrigger 
} from '../components/ui/accordion';

const Home = () => {
  const whatsappNumber = '+966555150324';
  const whatsappLink = `https://wa.me/${whatsappNumber.replace('+', '')}`;

  const services = [
    {
      icon: Snowflake,
      title: 'صيانة التكييف',
      description: 'حلول تبريد شاملة لراحتك على مدار السنة',
      image: 'https://housecraft.me/gfhdjsdhfd333.png',
      features: [
        'تركيب وفك مكيفات سبليت وشباك',
        'تنظيف وغسيل مكيفات',
        'تعبئة فريون',
        'إصلاح تسريب المياه',
        'صيانة دورية شاملة'
      ]
    },
    {
      icon: Zap,
      title: 'خدمات الكهرباء',
      description: 'حلول كهربائية آمنة وموثوقة',
      image: 'https://housecraft.me/gfhdjsdhfd333.png',
      features: [
        'تركيب وصيانة لوحات الكهرباء',
        'إصلاح التماسات والأعطال',
        'تركيب إنارة وثريات ومراوح',
        'تمديدات كهربائية كاملة'
      ]
    },
    {
      icon: Droplets,
      title: 'خدمات السباكة',
      description: 'خدمات سباكة متكاملة بأعلى جودة',
      image: 'https://housecraft.me/gfhdjsdhfd333.png',
      features: [
        'كشف وإصلاح تسريبات المياه',
        'تركيب خلاطات وسخانات',
        'تسليك مجاري',
        'تمديدات سباكة جديدة'
      ]
    }
  ];

  const features = [
    { icon: Users, title: 'فنيون محترفون', description: 'فريق من الخبراء المعتمدين' },
    { icon: Clock, title: 'خدمة 24/7', description: 'متوفرون على مدار الساعة' },
    { icon: Shield, title: 'ضمان الجودة', description: 'ضمان على جميع الخدمات' },
    { icon: ThumbsUp, title: 'أسعار منافسة', description: 'أسعار واضحة وعادلة' }
  ];

  const testimonials = [
    {
      name: 'أحمد المالكي',
      rating: 5,
      text: 'خدمة ممتازة وسريعة! جاء الفني في نفس اليوم وأصلح المكيف بكل احترافية. أنصح بالتعامل معهم',
      service: 'صيانة تكييف'
    },
    {
      name: 'محمد العتيبي',
      rating: 5,
      text: 'فنيين محترفين وأسعار معقولة. حلوا مشكلة الكهرباء عندي بسرعة وبدون أي تعقيدات',
      service: 'خدمات كهرباء'
    },
    {
      name: 'خالد السعيد',
      rating: 5,
      text: 'تعاملت معهم أكثر من مرة، دائماً على مستوى عالي من الاحترافية. شكراً لكم',
      service: 'خدمات سباكة'
    }
  ];

  const faqs = [
    {
      question: 'ما هي مناطق الخدمة؟',
      answer: 'نوفر خدماتنا في جميع أنحاء المملكة العربية السعودية مع تركيز خاص على المدن الرئيسية.'
    },
    {
      question: 'هل تقدمون ضمان على الخدمات؟',
      answer: 'نعم، نقدم ضمان شامل على جميع خدماتنا وقطع الغيار المستخدمة.'
    },
    {
      question: 'كم يستغرق وصول الفني؟',
      answer: 'نحرص على الوصول في أسرع وقت ممكن، عادة خلال ساعات من تلقي الطلب.'
    },
    {
      question: 'هل الأسعار شاملة قطع الغيار؟',
      answer: 'يتم تحديد السعر النهائي بعد الكشف. نوفر أسعار تنافسية وشفافة لجميع الخدمات.'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white" dir="rtl">
      {/* Header */}
      <header className="fixed top-0 w-full bg-white/95 backdrop-blur-md shadow-sm z-50 border-b border-slate-200">
        <div className="container mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-3">
              <a href="/">
                <img 
                  src="https://customer-assets.emergentagent.com/job_trusted-handyman-1/artifacts/bwyuu9dw_IMG_0972.jpeg" 
                  alt="هاوس كرافت - خدمات صيانة منزلية بريدة" 
                  className="h-12 w-auto"
                />
              </a>
            </div>
            <nav className="hidden md:flex items-center gap-6">
              <a href="/" className="text-cyan-600 font-semibold">الرئيسية</a>
              <a href="/services" className="text-slate-600 hover:text-cyan-600 font-semibold transition-colors">الخدمات</a>
              <a href="/about" className="text-slate-600 hover:text-cyan-600 font-semibold transition-colors">من نحن</a>
              <a href="/contact" className="text-slate-600 hover:text-cyan-600 font-semibold transition-colors">اتصل بنا</a>
            </nav>
            <Button 
              onClick={() => window.open(whatsappLink, '_blank')}
              className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <MessageCircle className="w-4 h-4 ml-2" />
              احجز الآن
            </Button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-cyan-50 via-white to-slate-50 opacity-60"></div>
        <div className="container mx-auto relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="inline-flex items-center gap-2 bg-cyan-100 text-cyan-700 px-4 py-2 rounded-full text-sm font-semibold">
                <Award className="w-4 h-4" />
                الخيار الأفضل للصيانة المنزلية
              </div>
              <h1 className="text-5xl lg:text-6xl font-bold text-slate-900 leading-tight">
                خدمات صيانة 
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-cyan-500"> تكييف وكهرباء وسباكة</span>
              </h1>
              <p className="text-xl text-slate-600 leading-relaxed">
                سرعة في الوصول وجودة مضمونة. نوفر لك أفضل خدمات الصيانة المنزلية بأيدي فنيين متخصصين ومعتمدين
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button 
                  size="lg"
                  onClick={() => window.open(whatsappLink, '_blank')}
                  className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white text-lg font-bold py-6 px-8 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                >
                  <MessageCircle className="w-5 h-5 ml-2" />
                  احجز الآن عبر واتساب
                </Button>
                <Button 
                  size="lg"
                  variant="outline"
                  onClick={() => window.open(`tel:${whatsappNumber}`, '_blank')}
                  className="border-2 border-cyan-600 text-cyan-600 hover:bg-cyan-50 text-lg font-bold py-6 px-8 rounded-xl transition-all duration-300"
                >
                  <Phone className="w-5 h-5 ml-2" />
                  اطلب خدمة فورية
                </Button>
              </div>
              <div className="flex items-center gap-8 pt-4">
                <div className="flex items-center gap-2">
                  <div className="flex">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                  <span className="text-slate-600 font-semibold">تقييم 5 نجوم</span>
                </div>
                <div className="h-8 w-px bg-slate-300"></div>
                <div className="text-slate-600">
                  <span className="font-bold text-cyan-600 text-2xl">+500</span> عميل راضٍ
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://housecraft.me/gfhdjsdhfd333.png"
                alt="فني محترف"
                className="relative rounded-3xl shadow-2xl w-full h-[500px] object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 px-4 bg-white">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
              خدماتنا المتميزة
            </h2>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              نقدم مجموعة شاملة من خدمات الصيانة المنزلية بأعلى معايير الجودة
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <Card key={index} className="group hover:shadow-2xl transition-all duration-300 border-2 hover:border-cyan-500 overflow-hidden">
                <div className="relative h-64 overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-4 right-4 bg-white p-3 rounded-xl shadow-lg">
                    <service.icon className="w-8 h-8 text-cyan-600" />
                  </div>
                </div>
                <CardContent className="p-6">
                  <h3 className="text-2xl font-bold text-slate-900 mb-2">{service.title}</h3>
                  <p className="text-slate-600 mb-4">{service.description}</p>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-slate-700">
                        <CheckCircle className="w-5 h-5 text-cyan-600 flex-shrink-0 mt-0.5" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Button 
                    onClick={() => window.open(whatsappLink, '_blank')}
                    className="w-full mt-6 bg-cyan-600 hover:bg-cyan-700 text-white font-semibold transition-colors"
                  >
                    اطلب الخدمة
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 px-4 bg-gradient-to-br from-slate-50 to-cyan-50">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
              لماذا تختارنا؟
            </h2>
            <p className="text-xl text-slate-600">
              نحن ملتزمون بتقديم أفضل تجربة خدمة لعملائنا
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((feature, index) => (
              <Card key={index} className="text-center p-8 hover:shadow-xl transition-all duration-300 bg-white border-2 hover:border-cyan-500 group">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-cyan-500 to-cyan-600 rounded-2xl mb-4 group-hover:scale-110 transition-transform duration-300">
                  <feature.icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">{feature.title}</h3>
                <p className="text-slate-600">{feature.description}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 px-4 bg-white">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
              آراء عملائنا
            </h2>
            <p className="text-xl text-slate-600">
              ثقة عملائنا هي أولويتنا
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <Card key={index} className="p-6 hover:shadow-xl transition-all duration-300 border-2 hover:border-cyan-500">
                <CardContent className="p-0">
                  <div className="flex items-center gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                  <p className="text-slate-700 mb-4 leading-relaxed">"{testimonial.text}"</p>
                  <div className="flex items-center justify-between pt-4 border-t border-slate-200">
                    <div>
                      <p className="font-bold text-slate-900">{testimonial.name}</p>
                      <p className="text-sm text-cyan-600">{testimonial.service}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 px-4 bg-slate-50">
        <div className="container mx-auto max-w-3xl">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
              الأسئلة الشائعة
            </h2>
            <p className="text-xl text-slate-600">
              إجابات على أكثر الأسئلة شيوعاً
            </p>
          </div>
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-white border-2 border-slate-200 rounded-xl px-6 hover:border-cyan-500 transition-colors"
              >
                <AccordionTrigger className="text-right text-lg font-semibold text-slate-900 hover:text-cyan-600">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 text-base leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 px-4 bg-gradient-to-br from-cyan-600 to-cyan-700 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>
        <div className="container mx-auto text-center relative z-10">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            تحتاج صيانة فورية؟
          </h2>
          <p className="text-xl text-cyan-50 mb-8 max-w-2xl mx-auto">
            نحن جاهزون لخدمتك الآن. لا تنتظر حتى تتفاقم المشكلة. تواصل معنا الآن واحصل على خدمة سريعة واحترافية في منزلك
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              size="lg"
              onClick={() => window.open(whatsappLink, '_blank')}
              className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white text-xl font-bold py-7 px-10 rounded-xl shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105"
            >
              <MessageCircle className="w-6 h-6 ml-2" />
              تواصل عبر واتساب الآن
            </Button>
            <a 
              href={`tel:${whatsappNumber}`}
              className="text-white text-xl font-semibold hover:text-cyan-100 transition-colors flex items-center gap-2"
            >
              <Phone className="w-6 h-6" />
              {whatsappNumber}
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-12 px-4">
        <div className="container mx-auto">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <img 
                src="https://customer-assets.emergentagent.com/job_trusted-handyman-1/artifacts/bwyuu9dw_IMG_0972.jpeg" 
                alt="هاوس كرافت" 
                className="h-12 w-auto mb-4 brightness-200"
              />
              <p className="text-slate-400">
                شريكك الموثوق في الصيانة المنزلية ببريدة
              </p>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">روابط سريعة</h3>
              <ul className="space-y-2 text-slate-400">
                <li><a href="/" className="hover:text-white transition-colors">الرئيسية</a></li>
                <li><a href="/services" className="hover:text-white transition-colors">الخدمات</a></li>
                <li><a href="/about" className="hover:text-white transition-colors">من نحن</a></li>
                <li><a href="/contact" className="hover:text-white transition-colors">اتصل بنا</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">خدماتنا</h3>
              <ul className="space-y-2 text-slate-400">
                <li>صيانة التكييف</li>
                <li>خدمات الكهرباء</li>
                <li>خدمات السباكة</li>
                <li>صيانة دورية</li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">تواصل معنا</h3>
              <div className="space-y-3">
                <a href={`tel:${whatsappNumber}`} className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors">
                  <Phone className="w-5 h-5" />
                  {whatsappNumber}
                </a>
                <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors">
                  <MessageCircle className="w-5 h-5" />
                  واتساب
                </a>
              </div>
            </div>
          </div>
          <div className="border-t border-slate-800 pt-8 text-center text-slate-400">
            <p>© 2024 هاوس كرافت. جميع الحقوق محفوظة.</p>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp Button */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 left-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-110 z-50 animate-pulse"
      >
        <MessageCircle className="w-7 h-7" />
      </a>
    </div>
  );
};

export default Home;
